import { logEvent } from "@/service/logs/log";
import { createPath } from "@/service/routing/routing";
import { PublicationCard } from "@/components/publication/publication-card";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";

export const Icd10PublicationCard = ({
  article,
  code,
}: {
  article: ArticlePreviewVM;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);

  return (
    <PublicationCard
      key={article.title}
      article={article}
      instantImageLoad={false}
      onClick={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: createPath(
            article.isVademecum ? "vademecum.show" : "publication.show",
            {
              categorySlug: article.category.slug,
              slug: article.slug,
            },
          ),
          resource_type: "article",
        });
      }}
    />
  );
};
